import { trpc } from '@/shared/api';

/** 어드민 견적 상세(quoteManagement.get) — 요청 내용·연락처·초안·메모·수정 요청·발행본 전부. */
export const useQuoteDetailQuery = (
  quoteRequestId: string,
  { enabled = true }: { readonly enabled?: boolean } = {},
) =>
  trpc.quoteManagement.get.useQuery(
    { quoteRequestId },
    // 없는 견적(NOT_FOUND)은 재시도해도 같다.
    { retry: false, enabled },
  );
